module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[6]249.53d5c0c.woff2";